import {atom} from "recoil";

const wordsAtom = atom({
    key: 'words',
    default: {}
});

export default wordsAtom;